import web from "../web";

class GenreService {
    index(token){
        return web.get("/api/genres", { headers: { 'Authorization': 'Bearer '+token } })
    } 
    liste(token){
        return web.get("/api/genres/get_id_libelles", { headers: { 'Authorization': 'Bearer '+token } })
    } 

    store(data, token){
        return web.post("/api/genres", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/genres/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/genres/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/genres/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new GenreService()